<label class="switch" [class.disabled]="disabled">
  <input
    type="checkbox"
    [checked]="selected"
    (change)="onChange($event)"
    [attr.disabled]="disabled ? '' : null"
  />
  <span class="slider round"></span>
</label>
